import { AiModelsApi, InitOverrideFunction, SupportedAiModelResponse } from "../../../@api";

export class AiModelsApiService
  implements Omit<AiModelsApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: AiModelsApi) {}

  public async aiModelsGetSupportedChatModel(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<SupportedAiModelResponse> {
    return this.api.aiModelsGetSupportedChatModel(initOverrides);
  }

  public async aiModelsGetSupportedImageModels(): Promise<Array<SupportedAiModelResponse>> {
    return this.api.aiModelsGetSupportedImageModels();
  }
}
